// Runtime env (docker-entrypoint.sh generatsiya qilgan env-config.js,
// window.__ENV__ orqali) build-time CRA env'dan (process.env, .env fayl /
// `npm start` uchun) ustun turadi.
const buildTimeEnv = {
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_API_KEY: process.env.REACT_APP_API_KEY,
};

export function getEnv(key) {
  const runtime = window.__ENV__ && window.__ENV__[key];
  if (runtime) return runtime;

  const buildTime = buildTimeEnv[key];
  if (buildTime) return buildTime;

  console.error(`[env] ${key} topilmadi (runtime va build-time env'da yo'q).`);
  return "";
}
